/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Ganturin Vladimir <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {AbstractControl, ValidatorFn} from '@angular/forms';

/**
 * Custom validation function.
 * Removes all non numeric symbols and checks length.
 * @param maxLength phone number length
 */
export function validatePhone(maxLength: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const cleaned = control.value.replace(/\D/g, '');
    return cleaned.length < maxLength ? {invalidLength: cleaned.length} : null;
  };
}
